export default "/images/11e1bdeabb647b920db6eac53dead349.avif";